
export default class ValidadorMascara {
    aplicar({validador, componente}) {
        componente.mascara = validador.mascara;        
    }

    validar({validador, valor}) {
        return (validador.mascara && validador.mascara.length !== undefined && validador.mascara.length === valor.length) || `O campo deverá ter o formato ${validador.mascara}`;
    }
}